var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button"},[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }